import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import contentAreaStyles from 'styles/contentArea';
import FlexBox from 'flexbox-react';
import PhaseForm from './components/phaseForm';
import { createPhase, navigate, clearValidationErrors, listOfRequests } from 'actionCreators';
import { urls } from 'helpers/url';
import connectUI from 'redux-ui';
import PhaseType from 'types/phase';

class PhaseNew extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = () => { this.props.navigate(urls.phases()); };
  }

  componentWillUnmount() {
    this.props.clearValidationErrors('PHASE');
  }

  handleSave(phase) {
    this.props.createPhase(phase)
      .then(() => this.props.navigate(
        urls.phaseLaborProductAccounting(this.props.phase),
      ))
      .catch(() => {});
  }

  render() {
    const { errors, phase, role } = this.props;

    return (<div>
      <FlexBox>
        <Helmet title="New Phase" />
        <div className={contentAreaStyles.contentAreaContainer}>
          <PhaseForm
            errors={errors}
            onSave={this.handleSave}
            onCancel={this.handleCancel}
            loading={phase.loading}
            role={role}
          />
        </div>
      </FlexBox>
    </div>);
  }
}

PhaseNew.propTypes = {
  phase: PhaseType,
  navigate: PropTypes.func,
  listOfRequests: PropTypes.func,
  requestSurfaceTypesList: PropTypes.func,
  clearValidationErrors: PropTypes.func,
  createPhase: PropTypes.func,
  errors: PropTypes.object,
  role: PropTypes.string,
};

const mapStateToProps = (state) => {
  const { user: { role = '' } = {} } = state;
  return {
    phase: state.phase.details,
    errors: state.phase.details.errors || {},
    role,
  };
};

export default connectUI()(connect(
  mapStateToProps, {
    navigate,
    createPhase,
    clearValidationErrors,
    listOfRequests,
  },
)(PhaseNew));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseEdit/phaseNew.jsx